import React from 'react';
import { useAuthStore } from '@/store';
import PersonalOnboardingFlow from './PersonalOnboardingFlow';

// A different account gets a separate controller, including its save queue.
export default function OnboardingFlow(props) {
  const userId = useAuthStore(s => s.user?.id);
  return <PersonalOnboardingFlow key={userId || 'guest'} {...props} />;
}
